const defaultCardSettings = {
    headerSettings: {
      title: "",
      titleFontWeight: 100,
      subTitle: "",
      avatar: "",
      headerImage: {
        images:{
          small:'',
          medium:'',
          large:''
        }
      }
    },
    backgroundSettings:{
      backgroundColor: "#ffff", 
      backgroundImage: null
    },
    bodySettings:{
      fontColor: '#ffff',
      direction: 'rtl'
    },
    actionsSettings: {
      color:"#ffff",
      textColor:"#ffff",
    },
    detailsSettings:{
      servicesTitle:'שירותים:',
      openingHoursTitle:'שעות פעילות'
    },
    shareSettings:{
      title:'שתפו את כרטיס הביקור באמצעות:'
    },
    footerSettings: {
      title:'כרטיס הביקור נבנה ע"י Smartcard',
      buttonText:"לפרטים נוספים",
      link:'https://www.instagram.com/smart_card_/',
    }
  };
  
  const ClientInfo = {
    businessname:'',
    phoneNumber:'',
    whatsapp:'',
    location:'',
    facebook:'',
    instagram:'',
    about:'',
    openingHours:'',
    servicesDescription:'',
    status: 'NEW'
  }
  
  const EditorSettings = {
  
    mode: 'EDIT',
    previewResolution: {
      width:'800px',
      height:'1280px'
    }
  
  };
  
  const initialState = {
    businessCards: {
      // isLoading: false,
      // success: false,
      // error: null,
      // data:{
      // status: 'NEW',
      // settings: defaultCardSettings,
      // clientInfo: ClientInfo,
      //deletedActions: [],
      cardActions: {
        actions:[],
        deletedActions:[]
      },
      images: {
        avatar:{},
        backgroundImage:{},
        headerImage:{},
        galleryImages:[],
        deletedImages:[]
      },
    },
    app:{
      snackbar:{
        notifications:[],
      }
    },
    editor:{
      settings: EditorSettings,
      isLoading: false
    }
  }

  export default initialState;